module.exports = __webpack_public_path__ + "static/media/2.9268586d.png";